import { getServerURL } from '../../Utils/getServerURL';
import Logger, { namedError } from '../../Utils/Logger';

export interface IMailArgs {
  receivers: string;
  copyReceivers?: string;
  body: string;
  subject: string;
  sendMail: true;
  sender?: string; //Email - Anges normalt inte
  senderName?: string; //Namn - Anges normalt inte
}

/**
 * Tar in ett objekt med arguments för en rapport tex Fakturabild men förväntar sig även ett antal IMailArgs för att kunna skicka ett mail
 * Kolla i FakturaattestMailFakturaBildModal.tsx för exempel på hur detta är implementerat
 * @param args - T extends IMailArgs & { reportName: string; fileName: string }
 * @returns Promise<string>
 */
export const sendReportAsMail = <
  T extends IMailArgs & { reportName: string; fileName: string }
>(
  args: T
): Promise<string> => {
  return new Promise((resolve, reject) => {
    fetch(`${getServerURL()}/pdf?reportName=${args.reportName}`, {
      method: 'POST',
      credentials: 'include',
      body: JSON.stringify(args),
    })
      .then(async response => {
        if (!response.ok) {
          const text = await response.text();
          Logger.warn(
            namedError(
              'ExportToPDFUtils-sendReportAsMail',
              response.statusText + ': ' + text
            )
          );
          reject('Ett fel inträffade. ' + text);
        }

        if (response.ok) {
          resolve('Mailet har skickats');
        }
      })
      .catch(e => {
        Logger.error(e);
        reject('Ett fel inträffade. ' + e);
      });
  });
};
